/**
 * <fragrance-details-slider>
 * Reuses the global Swiper bundle. Loop, no autoplay, clickable dots + arrows.
 */
class FragranceDetailsSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.fragrance-slider');
    if (!this.slider || this.slider.swiper) return;
    this.whenSwiperReady(() => this.init());
  }

  disconnectedCallback() {
    if (this.slider && this.slider.swiper) this.slider.swiper.destroy(true, true);
  }

  whenSwiperReady(cb) {
    if (typeof Swiper !== 'undefined') {
      cb();
      return;
    }
    let attempts = 0;
    const timer = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (++attempts > 50) {
        clearInterval(timer);
        console.error('fragrance-details-slider: Swiper failed to load');
      }
    }, 100);
  }

  init() {
    new Swiper(this.slider, {
      slidesPerView: 1,
      loop: this.slider.querySelectorAll('.swiper-slide').length > 1,
      pagination: {
        el: this.querySelector('.fragrance-details__dots'),
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      navigation: {
        prevEl: this.querySelector('.fragrance-details__arrow--prev'),
        nextEl: this.querySelector('.fragrance-details__arrow--next')
      }
    });
  }
}

if (!customElements.get('fragrance-details-slider')) {
  customElements.define('fragrance-details-slider', FragranceDetailsSlider);
}
